import { useTranslation } from 'react-i18next';

/**
 * Re-export of react-i18next's `useTranslation` with a default namespace.
 * Components call `const { t } = useT('navigation');` and then `t('home')`.
 *
 * Once `i18next-types` is installed (Phase 2 follow-up), this hook will be
 * upgraded to return a strongly-typed `t` function bound to the namespace's
 * generated key set. For Phase 0 the underlying `t` accepts arbitrary keys.
 */
export function useT(ns?: string) {
  return useTranslation(ns);
}
